import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import LottieAnimation from './LottieAnimation';

interface PlanetOrangeProps {
  className?: string;
  size?: number;
}

const PlanetOrange: React.FC<PlanetOrangeProps> = ({ className = '', size = 200 }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20,
      });
    };

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box
      className={`fixed top-20 right-10 opacity-60 pointer-events-none ${className}`}
      sx={{
        width: size,
        height: size,
        transform: `translate(${mousePosition.x}px, ${mousePosition.y + scrollY * 0.1}px)`,
        transition: 'transform 0.1s ease-out',
        animation: `
          float 6s ease-in-out infinite,
          pulse 4s ease-in-out infinite,
          glow 8s ease-in-out infinite
        `,
        '@keyframes float': {
          '0%, 100%': {
            transform: 'translateY(0px)',
          },
          '25%': {
            transform: 'translateY(-8px)',
          },
          '50%': {
            transform: 'translateY(-4px)',
          },
          '75%': {
            transform: 'translateY(-12px)',
          },
        },

        '@keyframes pulse': {
          '0%, 100%': {
            transform: 'scale(1)',
          },
          '50%': {
            transform: 'scale(1.05)',
          },
        },
        '@keyframes glow': {
          '0%, 100%': {
            filter: 'drop-shadow(0 0 8px rgba(255, 165, 0, 0.3))',
          },
          '50%': {
            filter:
              'drop-shadow(0 0 16px rgba(255, 165, 0, 0.6)) drop-shadow(0 0 24px rgba(255, 165, 0, 0.3))',
          },
        },
      }}
    >
      <LottieAnimation
        src="/src/assets/lottie/planet_orange.lottie"
        loop={true}
        autoplay={true}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    </Box>
  );
};

export default PlanetOrange;
